import { request } from "@/interface/helper";

const str = "settingBanner";

export const settingBanner = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/banner/list" }),
    add: data => request({ data, method: "post", url: "/banner/add" }),
    detail: data => request({ data, method: "post", url: "/banner/detail" }),
    edit: data => request({ data, method: "post", url: "/banner/modify" }),
    transfer: data => request({ data, method: "get", url: "/banner/transfer" }),
    setLangDetail: data => request({ data, method: "post", url: "/banner/setlangdetail" })
  }
};
